import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/*引入公共css文件*/
import './assets/css/common.css'

/*引入签名插件*/
import vueEsign from 'vue-esign'
Vue.use(vueEsign)

/*引入axios*/
import axios from 'axios'
Vue.prototype.$axios = axios;

/*引入px转rem适配文件*/
import 'lib-flexible'

/*引入fastclick文件 禁止放大缩小*/
import fastClick from 'fastclick'
fastClick.attach(document.body)

/*引入html5plus*/
import Mui from 'vue-awesome-mui';
Vue.config.productionTip = false
Vue.use(Mui);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
